import { h, Component, Prop, Host } from '@stencil/core';

import { getVariableGeneric } from '../../../services/utils';

/**
 * @part base - The component's base wrapper.
 * @part timeline - The timeline that connects the events.
 */
@Component({
  tag: 'pk-match-facts',
  styleUrl: './scss/pk-match-facts.scss',
  shadow: true,
})
export class PkMatchFact {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** The gap between the fact event items, it can be a valid spacing tokens or a number (pixels) */
  @Prop({ reflect: true }) gap: string | number;

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    const style = {
      ...(this.gap && { '--pk-match-facts--items-gap': getVariableGeneric(this.gap, 'px') }),
    };

    return (
      <Host style={style}>
        <div
          class="pk-match-facts relative flex flex-col items-center justify-start gap-[--pk-match-facts--items-gap] bg-[--pk-match-facts--background-color]"
          part="base"
        >
          <span class="pk-match-facts__timeline absolute inline-block h-full" part="timeline" />
          <slot />
        </div>
      </Host>
    );
  }
}
